import React from 'react'
import Button from '@material-ui/core/Button'
import Logo from '../../logo_fgml.png'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  footer: {
    maxWidth: 500,
    fontSize: 12,
    margin: '1em auto 2em',
    textAlign: 'left',
    color: theme.palette.grey[700],
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      fontWeight: 'bolder'
    }
  }
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <footer style={{ textAlign: 'center' }}>
      <Divider />
      <div style={{ margin: '1em' }}>
        <Button color="inherit" href="https://fundacionmohme.org/">
          <img
            style={{ width: 150 }}
            src={Logo}
            alt="Fundacion Gustavo Mohme"
          />
        </Button>
        <div>
          <p className={classes.footer}>
            <i>
              Una iniciativa del Proyecto Talleres de Periodismo de la{' '}
              <a href="https://fundacionmohme.org/">
                Fundación Gustavo Mohme Llona
              </a>
              , con participación de estudiantes de las escuelas y facultades de
              periodismo y comunicación de la Universidad Nacional del Santa, la
              Universidad Nacional de Piura, la Universidad Nacional de Pucallpa
              y la Universidad Nacional de San Antonio Abad de Cusco.
            </i>
          </p>
          <p className={classes.footer}>
            COORDINACIÓN: Wilber Huacasi. PROGRAMACIÓN: Melissa Chávez.
            PERIODISTA: Ghiomara Rafaele (UNMSM). FUENTE: JNE.
          </p>
          <p className={classes.footer}>Contacto: info@fundacionmohme.org</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
